<template>
  <div v-show='isShow'>
    <div class="appoint-div">
      <div class="headPhoto">
        <img :src="imgUrl" alt="" />
        <h2 style='margin-top:10px'>{{ this.name }}</h2>
      </div>
      <div class="textInfo">
        <div class="titleTop">
          <img
            src="../../../../assets/img/test/appointGulider/smallBgc.png"
            alt=""
          />
          <h2>{{ this.slogan }}</h2>
        </div>
        <div class="titileMiddle">
          <h3>{{ this.middleInfo }}</h3>
        </div>
        <div class="titileBottom">
          <h3>{{ this.introduction }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { guilderInfo } from "@/http/api";
export default {
  data() {
    // url:'www.baidu.com'
    return {
      //导师头像地址
      imgUrl: "",
      //导师姓名
      name: "",
      //导师简介
      introduction: "",
      //导航标语
      slogan: "",
      //中间广告语
      middleInfo: "",
      //导师Id,
      guilderId: "",
    };
  },
  props: {
    isShow:Boolean,
  },
  methods: {
    toApplets() {
      window.location.href = this.url;
    },
    getGuilderInfo() {
      guilderInfo()
        .then((res) => {
          //获取随机数
          let randNum = this.getRandNum(1, res.data.count);
          // console.log(res)
          this.imgUrl = res.data.objects[randNum].avatar;
          this.name = res.data.objects[randNum].nick_name;
          this.introduction = res.data.objects[randNum].introduction;
          this.slogan = res.data.objects[randNum].slogan;
          this.middleInfo = res.data.objects[randNum].position;
          this.guilderId = res.data.objects[randNum].oid;
          //组件通讯，把这个id传入连接小程序的组件
          this.$bus.$emit("getGuilderId", { id: this.guilderId });
        })
        .then((err) => {
          console.log(err);
        });
    },
    //获取随机数
    getRandNum(start, end) {
      return Math.floor(Math.random() * (end - start) + start);
    },
  },
  created() {
    this.getGuilderInfo();
  },
};
</script>
<style lang="less" scoped >
.appoint-div {
  // height: 100px;
  height: 115px;
  display: flex;
  position: fixed;
  bottom: -3px;
  left: 0;
  width: 100%;
  z-index: 99;
  // background-color: pink;
  background: url("../../../../assets/img/test/appointGulider/bgc0.png")
    no-repeat;
  background-size: 100% 100%;
  .headPhoto {
    position: absolute;
    width: 86px;
    height: 86px;
    bottom: 59px;
    left: 5px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    h2 {
      font-weight: Medium;
      font-family: "思源黑体 CN Medium";
      font-size: 15px;
      text-align: center;
    }
  }
  .textInfo {
    .appoint_imm {
      position: absolute;
      text-align: center;
      flex-direction: column;
      width: 85px;
      height: 35px;
      bottom: 14px;
      right: 15px;
      font-size: 15px;
      font-family: "思源黑体 CN Medium";
      line-height: 35px;
      color: #fff;
      background-size: contain;
      background: url("../../../../assets/img/test/appointGulider/bgc1.png")
        no-repeat;
      
      // background-color: pink;
    }
    .titleTop {
      display: flex;
      position: absolute;
      width: 227px;
      height: 17px;
      // background-color: pink;
      top: 19px;
      left: 95px;
      img {
        margin-right: 5px;
      }
      h2 {
        font-family: "思源黑体 CN Medium";
        font-weight: Medium;
        font-size: 15px;
        color: "#291300";
        line-height: 17px;
      }
    }
    .titileMiddle {
      position: absolute;
      // width: 146px;
      height: 13px;
      left: 94px;
      top: 47px;
      // background-color: pink;
      h3 {
        // width: 100%;
        font-size: 13px;
        font-weight: normal;
        font-family: "思源黑体 CN Normal";
      }
    }
    .titileBottom {
      position: absolute;
      display: flex;
      width: 177px;
      height: 13px;
      // background-color: pink;
      left: 93px;
      top: 70px;
      h3 {
        width: 115px;
        // background-color: skyblue;
        font-size: 12px;
        font-weight: normal;
        font-family: "思源黑体 CN Normal";
        color: #4a4a4a;
      }
      div {
        margin-right: 3px;
        //  background-color: blue;
        font-size: 12px;
        color: #42686e;
        font-weight: normal;
      }
    }
  }
}
</style>
